export default "__VITE_ASSET__BEoUOUuD__"